import { Route } from 'react-router-dom'
import MutualFundDetailPage from '../pages/MutualFundDetailPage'
import InvestmentTransactionsPageV2 from '../features/user-investment/pages/InvestmentTransactionsPageV2'
import InvestmentTransactionsPage from '../features/user-investment/pages/InvestmentTransactionsPage'

export const MutualFundRoutes = () => {
  return [
    <Route path='/mutual-fund/:isin/transactions' element={<InvestmentTransactionsPage />} />,
    <Route path='/mutual-fund/:isin/transactions-v2' element={<InvestmentTransactionsPageV2 />} />,
    <Route path='/mutual-fund/:isin' element={<MutualFundDetailPage />} />
  ]
}
